// Generated by packages/brand/scripts/generate.ts from masters/baton-b.svg. Do not edit: replace the master and run `bun run brand:icons`.
import type { BrandMark } from "../shape.ts";

/** The B mark alone, centred on a square. */
export const mark: BrandMark = {
  viewBox: "100.94 200.94 346.36 346.36",
  width: 346.36,
  height: 346.36,
  d: "m361.9 369.5c18.2 10.9 33.6 25.2 41.9 45.2 17 41.4-6.7 86.7-45.5 105.1-25.2 11.8-54.8 8.2-81.8 8.1-30 0-60 0-90 0-9.7 0-19.3 0-29 0-6 0-12.3.5-18.3-.4 69.9-68.7 139.8-137.3 209.7-206-12.1-1.5-25.1-.4-37.4-.4-10.6.1-21.7-1-31.6 3.3-12.6 5.5-26.3 21.9-36.3 31.6-20 19.4-40.3 38.4-60.1 58-8.5 8.5-17.1 16.9-25.8 25.1-3.3 3.1-6.2 6.5-9.9 8.8 0-75.8 0-151.5 0-227.3 14.5-.7 29.2-.2 43.7-.2 27.7 0 55.3 0 83 0 22.5 0 51.8-2.9 73 4.7 41.2 14.9 64.1 59.3 48.1 101-4.4 11.4-11.2 21.6-19.6 30.4-4.3 4.5-10.5 8.1-14.1 13z",
  fillRule: "evenodd",
  strokeWidth: 0.25,
  strokeLinejoin: "round",
};
